<template lang="pug">
.theindex-post
  Hero.section(
    image="/theindex/2023%20Headers/new%20-%202000%20x%20300/index-hero-2024-1_x1n9ux.jpg"
    logo
    subtitle="A knowledge base of product and movement information, lifestyle content and strength history."
  )
  .main-container
    .filters
      CategoryNav.category-nav
      .filler
      .search-field
        RogueInput#index-input-search.search(:placeholder="__('Search The Index')" v-model="query" @keyup.enter="search()")
        .search-btn.btn(@click.stop="search()")
          Icon(name="search")
    .clear-search(v-if="searchFor")
      h3
        | {{ __('Search results for:') }}&nbsp;
        | {{searchFor}}
      .clear-search-btn(@click="search('')")
        Icon.icn(name="x" color="#333")
    .section(v-if="searchFor")
      PostsGrid.section(
        :ssr="true"
        :query="{search: searchFor}"
        :limit="9"
        :showFilters="false"
        :showFeatured="true"
      )
    .all-sections(v-else)
      .section(v-for="(category, idx) in categories" :key="category.id")
        h2.underline {{ __(category.name) }}
        PostsGrid.section(
          :ssr="idx === 0"
          :query="{categories:category.id, search: searchFor}"
          :limit="9"
          :showFilters="false"
          :showFeatured="true"
        )
</template>

<script setup lang="ts">
import { defineAsyncComponent, hydrateOnVisible, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useHead } from '@unhead/vue'
import CategoryNav from './components/category-nav.vue'
import Hero from './components/hero.vue'
import IndexCard from './components/index-card.vue'
import { INDEX_CATEGORY_MAP } from './data'
import { useIndexSearch } from './helpers/search'
import metadata from '@/js/helpers/metadata'
import { useRogue } from '@/js/services/Rogue'

const { query, searchFor, search } = useIndexSearch()

const PostsGrid = defineAsyncComponent({
  loader  : () => import('@/js/pages/theindex/components/posts-grid.vue'),
  hydrate : hydrateOnVisible(),
})

const rogue = useRogue()
const route = useRoute()
const router = useRouter()

const categories = [17, 18, 330, 804, 805, 806, 103, 19, 105, 104]
  .map(id => ({ id, name: INDEX_CATEGORY_MAP[id]?.name, featured: null, slug: INDEX_CATEGORY_MAP[id]?.slug }))

useHead(metadata({
  title       : rogue.__('The Index'),
  description : rogue.__('A knowledge base of product and movement information, lifestyle content and strength history.'),
  image       : '/theindex/2023%20Headers/new%20-%202000%20x%20300/home_ia101k.jpg',
  robots      : 'all',
  url         : rogue.localizedBaseURL + route.path }, rogue)
)

watch(() => route.query.q, (newVal) => {
  searchFor.value = newVal as string || ''
  query.value = newVal as string || ''
}, {
  immediate: true,
})

</script>

<style lang="scss" scoped>
.section {
  margin-bottom: $space-xxl;
}

.category-nav.cat-link-wrapper {
  margin-bottom: $space-m;

  @include not-mobile() {
    margin-top: $space-xs;
    margin-right: $space-xs;
  }
}

.filters {
  margin-bottom: $space-m;
  display: flex;
  justify-content: space-between;

  @include mobile(){
    flex-direction: column;
  }
}

.search-field {
  position: relative;

  :deep(){
    input{
      padding-right: $space-xl;
    }
  }
}

.search {
  min-width: 250px;
}

.search-btn {
  position: absolute;
  top: 0;
  right: 4px;
  padding: 12px 8px;
  cursor: pointer;
}

.clear-search {
  margin-bottom: $space-l;
  display: flex;
  align-items: center;

  h3 {
    margin-bottom: 0;
  }
}

.clear-search-btn {
  cursor: pointer;
  margin-left: $space-s;
  .icn {
    height: 14px;
    width: 14px;
  }
}

.featured-post {
  margin-bottom: $space-xxl;
  display: block;
}

.featured-post :deep(.img-container) {
  padding-bottom: 56.25%;

  img {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

@media (max-width: 1328px) {
  :deep(.no-results-found){
    margin-left: -24px;
    margin-right: -24px;
  }
}

@include mobile(){
  :deep(.no-results-found){
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
